const pills        = document.getElementsByClassName('pill-header')[0].children;
const pill_content = document.getElementsByClassName('pill-content')[0].children;

pills[0].classList.add('active');
pill_content[0].classList.add('active');         

for (var i = 0; i < pills.length; i++) {
    pills[i].onclick = function () {
        if(this.classList.contains('active')) {
            // Do nothing here
        } else {
            for (var i = 0; i < pills.length; i++) {                
                if(pills[i].classList.contains('active')) {
                    pills[i].classList.remove('active');   
                    pill_content[i].classList.remove('active');
                }             
            }
            this.classList.add('active');
            pill_content[this.dataset.pill].classList.add('active');            
        }
    }
}